import { Builder } from '@builder.io/react'

import { SKUSelectionErrorMessageDefaults } from '@src/components/SKUSelectionErrorMessage/SKUSelectionErrorMessage.defaults'

import { SKUSelectionErrorMessage } from './SKUSelectionErrorMessage'

Builder.registerComponent(SKUSelectionErrorMessage, {
  name: 'SKUSelectionErrorMessage',
  noWrap: true,
  inputs: [
    {
      name: 'errorMessage',
      helperText: 'Displayed when the required items are not selected in rails.',
      type: 'html',
      localized: true,
      defaultValue: SKUSelectionErrorMessageDefaults.errorMessage,
    },
  ],
})
